import React from 'react';
import { motion } from 'framer-motion';
import { Layers, Target, Clock, Zap } from 'lucide-react';
export function ProductFeatures() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const features = [{
    icon: Layers,
    title: 'Miles de diseños organizados',
    desc: 'Por categorías y subcarpetas para que encontrar el indicado esté a un solo clic.'
  }, {
    icon: Target,
    title: 'Diseños pensados para producción real',
    desc: 'Dejá de improvisar y empezá a vender desde el primer día.'
  }, {
    icon: Clock,
    title: 'Te ahorra horas todos los días',
    desc: 'Olvidate de buscar ideas que no funcionan y enfocá tu tiempo en vender.'
  }, {
    icon: Zap,
    title: 'Un solo sistema para dejar de improvisar',
    desc: 'Pasá de "tengo una máquina" a "tengo un negocio que factura".'
  }];
  return <section className="py-14 md:py-16 bg-[#0a0e1a]" data-id="element-163">
      <div className="max-w-[980px] mx-auto px-4" data-id="element-164">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12" data-id="element-165">
          {features.map((feature, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: idx % 2 === 0 ? -16 : 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.08
        }} className="flex items-start space-x-5 bg-[#1a1f35] p-5 rounded-xl border border-white/5" data-id="element-166">
              <div className="bg-[#f5a623]/20 p-3 rounded-xl flex-shrink-0" data-id="element-167">
                <feature.icon className="w-6 h-6 text-[#f5a623]" data-id="element-168" />
              </div>
              <div data-id="element-169">
                <h3 className="text-lg font-bold text-white mb-1.5" data-id="element-170">
                  {feature.title}
                </h3>
                <p className="text-[17px] text-gray-400" data-id="element-171">{feature.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="flex justify-center" data-id="element-172">
          <motion.button initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={scrollToPricing} className="btn-primary !px-8 !py-3.5 !text-base md:!text-lg" data-id="element-173">
            VER OFERTA
          </motion.button>
        </div>
      </div>
    </section>;
}